/* istanbul ignore file */
/* tslint:disable */
 

/**
 * * `refund` - Refund
 * * `credit` - Credit
 */
export enum RefundDestinationEnum {
  REFUND = 'refund',
  CREDIT = 'credit',
}
